export enum ENUM__generation_scheduler {
  DDIM = 'ddim', //       deterministic
  DDPM = 'ddpm', //       stochastic
  DEIS = 'deis', //       deterministic
  DEIS_K = 'deis_k', //   deterministic + karras
  LMS = 'lms', //         stochastic
  LMS_K = 'lms_k', //     stochastic + karras
  PNDM = 'pndm', // stochastic
  HEUN = 'heun', // stochastic
  HEUN_K = 'heun_k', // stochastic + karras
  EULER = 'euler', // stochastic
  EULER_K = 'euler_k', // stochastic + karras
  EULER_A = 'euler_a', // ancestral
  KDPM_2 = 'kdpm_2', // deterministic
  KDPM_2_K = 'kdpm_2_k', // deterministic + karras
  KDPM_2_A = 'kdpm_2_a', // ancestral
  KDPM_2_A_K = 'kdpm_2_a_k', // ancestral + karras
  DPMPP_2S = 'dpmpp_2s', // deterministic
  DPMPP_2S_K = 'dpmpp_2s_k', // deterministic + karras
  DPMPP_2M = 'dpmpp_2m', // multi-step
  DPMPP_2M_K = 'dpmpp_2m_k', // multi-step + karras
  DPMPP_2M_SDE = 'dpmpp_2m_sde', // sde
  DPMPP_2M_SDE_K = 'dpmpp_2m_sde_k', // sde
  DPMPP_3M = 'dpmpp_3m', // multi-step
  DPMPP_3M_K = 'dpmpp_3m_k', // multi-step + karras
  DPMPP_SDE = 'dpmpp_sde', // sde
  DPMPP_SDE_K = 'dpmpp_sde_k', // sde
  UNIPC = 'unipc', // adaptive
  UNIPC_K = 'unipc_k', // adaptive + karras
  LCM = 'lcm', // learned
  TCD = 'tcd', // ?
}
